// extracted by mini-css-extract-plugin
module.exports = {"width":"HealthCareHeroes_width__QDwj5","truncate":"HealthCareHeroes_truncate__1CNdx"};